/* eslint-disable max-len */
import { ThemeType } from '../../theme/jss-types';

export const walletStyles = (theme: ThemeType) => ({
    main: {
        width: '100%',
        padding: '5px 6px 6px 3px',
        height: '100%',
    },
    pageFilter: {
        display: 'flex',
        marginTop: 8,
    },
    pageName: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        letterSpacing: 0,
        color: '#666666',
        padding: '6px 16px',
        cursor: 'pointer',
        borderRadius: '4px 4px 0 0',
        backgroundColor: '#F5F5F5',
        marginRight: 2,
    },
    selectedPage: {
        fontSize: 14,
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        letterSpacing: 0,
        color: '#111111',
        padding: '6px 16px',
        backgroundColor: '#FFFFFF',
        borderRadius: '4px 4px 0 0',
        marginRight: 2,
    },
    bucket: {
        color: '#666666',
        fontFamily: 'Open Sans',
        fontSize: 14,
        letterSpacing: 0,
        padding: '6px 16px',
        marginRight: 2,
        borderRadius: '4px 4px 0 0',
        backgroundColor: '#F5F5F5',
        display: 'flex',
        cursor: 'pointer',
    },
    count: {
        height: 18,
        width: 28,
        borderRadius: 9,
        backgroundColor: '#E9E9E9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        fontSize: 12,
        color: '#333',
        fontWeight: 600,
    },
    filter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    filterText: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 11,
        letterSpacing: 0,
        marginRight: 8,
    },
    countSelected: {
        backgroundColor: theme.primaryColor,
        color: '#FFF',
        fontWeight: 'bold',
    },
    cellValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        cursor: 'pointer',
    },
    cellNa: {
        color: '#999999',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
    },
    bucketSelected: {
        color: '#111111',
        fontWeight: 'bold',
        backgroundColor: '#FFF',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    moreFilter: {
        marginLeft: 16,
        fontWeight: 600,
        fontSize: 12,
        cursor: 'pointer',
        color: theme.primaryColor,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    bucketRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    bucketName: {
        marginRight: 12,
    },
    extraFilters: {
        width: '100%',
        borderRadius: '0 2px 0 0',
        backgroundColor: '#FFFFFF',
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
        flexDirection: 'row',
    },
    dateFilter: {
        width: '100%',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        '& .ant-picker': {
            borderRadius: '6px',
            width: 215,
            height: 32,
        },
        '& .ant-picker-input > input': {
            fontSize: '13px',
        },
    },
    dateRange: {
        '& .ant-picker-cell-in-view::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-cell:hover .ant-picker-cell-in-view:hover::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-panel-container': {
            backgroundColor: '#f7f7f7 !important',
            borderRadius: '4px !important',
            display: 'flex !important',
            flexDirection: 'row-reverse !important',
        },
        '& .ant-picker-cell-in-view .ant-picker-cell-inner': {
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
            width: '32px !important',
            height: '32px !important',
            padding: '0 !important',
            backgroundColor: 'white !important',
            borderRadius: '4px !important',
            margin: '1px !important',
            boxSizing: 'border-box !important',
            '&:hover': {
                backgroundColor: '#b9e0ff !important',
            },
        },
        '& .ant-picker-cell-in-view': {
            padding: '0 !important',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.secondaryFillColor} !important`,
            borderColor: `${theme.secondaryFillColor} !important`,
            fontWeight: 'bold !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-disabled::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-footer': {
            minWidth: 140,
            padding: 4,
        },
        '& .ant-picker-ranges .ant-picker-preset > .ant-tag-blue': {
            color: 'black',
            background: 'transparent !important',
            borderColor: 'transparent !important',
            fontWeight: 600,
            fontSize: '12px',
            padding: '8px',
        },
        '& .ant-picker-ranges > li:hover': {
            display: 'inline-block',
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            borderRadius: '4px',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner': {
        },
    },
    recharge: {
        display: 'flex',
        alignItems: 'center',
    },
    cashNCarry: {
        fontWeight: 'bold',
        width: '100%',
        borderRadius: '0 2px 0 0',
        padding: '10px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
        backgroundColor: '#1A1A1A',
        alignItems: 'center',
        color: '#FFFFFF',
    },
    balanceDiv: {
        display: 'flex',
        width: '50%',
    },
    img: {
        height: 40,
    },
    balanceText: {
        fontSize: 10,
        color: '#FFFFFF',
        fontWeight: 500,
    },
    signText: {
        fontSize: 19,
        color: '#FFFFFF',
        fontWeight: 700,
        marginLeft: '5%',
    },
    reloadSvgButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    reloadIcon: {
        color: 'blue',
        cursor: 'pointer',
    },
    reloadDisabled: {
        color: 'gray !important',
        cursor: 'not-allowed !important',
    },
    openingClosingBalanceSecton: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '17px',
        margin: '0px 8px',
    },
    balanceSection: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    balance: {
        marginLeft: '5%',
        display: 'flex',
        alignItems: 'center',
        jusrtifyContent: 'center',
        flexDirection: 'column',
    },
    leftFilters: {
        display: 'flex',
        alignItems: 'center',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input': {
            height: 28,
            borderRadius: 4,
        },
        '& .ant-btn': {
            boxSizing: 'border-box',
            height: 28,
            borderRadius: 3,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
            laterSpacing: 0,
        },
        '& .ant-btn-ghost': {
            border: `1px solid ${theme.primaryColor} `,
            borderRadius: '4px  !important',
            width: '30px',
            height: '30px',
        },
        '& .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus': {
            backgroundColor: theme.primaryColor,
        },
        '& .ant-dropdown-menu-submenu-title': {
            padding: '12px 4px',
        },
        '& .ant-select-selector': {
            borderRadius: '4px 0 0 4px !important',
        },
        '& .ant-input': {
            borderLeft: 'none !important',
            borderRadius: '0 4px 4px 0 !important',
        },
    },
    rightFilters: {
        display: 'flex',
        alignItems: 'center',
        '& .ant-btn': {
            boxSizing: 'border-box',
            height: 28,
            borderRadius: 3,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
            laterSpacing: 0,
        },
        '& .ant-btn-ghost': {
            border: `1px solid ${theme.primaryColor} `,
        },
        '& .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus': {
            backgroundColor: theme.primaryColor,
        },
        '& .ant-dropdown-menu-submenu-title': {
            padding: '12px 4px',
        },
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input': {
            height: 28,
        },
        '& .ant-select-selector': {
            borderRadius: '4px 0 0 4px !important',
        },
        '& .ant-input': {
            borderLeft: 'none !important',
            borderRadius: '0 4px 4px 0 !important',
        },
    },
    downloadBtn: {
        marginRight: 8,
    },
    settingIcon: {
        color: '#333333',
        fontSize: 20,
        cursor: 'pointer',
        marginLeft: 8,
    },
    modal: {
        '& .ant-modal-header': {
            backgroundColor: '#065492',
            borderRadius: '4px 4px 0 0',
            padding: '16px 12px',
        },
        '& .ant-modal-footer': {
            backgroundColor: '#065492',
            borderRadius: '0 0 4px 4px',
            padding: '16px 12px',
            color: '#FFFFFF',
            fontSize: 10,
            textAlign: 'center',
        },
        '& .ant-modal-title, .ant-modal-close-x': {
            color: '#FFFFFF',
        },
        '& .ant-modal-content': {
            borderRadius: 4,
        },
        '& .ant-modal-body': {
            padding: 12,
        },
        '& .ant-btn-primary': {
            fontSize: 12,
            fontWeight: 600,
        },
        top: '11%',
        left: '30%',
    },
    filters: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    footer: {
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F7F7F7',
    },
    faqText: {
        color: '#FFFFFF',
        fontFamily: 'Open Sans',
        fontSize: 10,
        letterSpacing: 0,
        marginRight: 5,
    },
    faqBox: {
        display: 'flex',
        alignItems: 'center',
    },
    paymentAddition: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        width: '20%',
        backgroundColor: '#E6F2FF !important',
        borderRadius: '5px !important',
    },
    paymentButtonsCollection: {
        marginTop: '30px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
});
